export const GAMESTATE_VERSION = '2.0';

export const WORKSHOP_STATE_VERSION = '2.10';

export const WORKSHOP_ONBOARDING_QUEST_IDS = [301, 309];

export const WORKSHOP_END_QUEST_IDS = [308, 316];

export const CURIOSO_POWER = {
  DEFAULT: 'Curioso Powers',
  BOOK_MAGIC: 'Book Magic',
  INSPIRATION: 'Inspiration',
  MIND_READER: 'Mind Reader',
};

export const GLYPH_POWER = {
  SHADE_SHIFTER: 'Shade Shifter',
  PORTALING: 'Portaling',
  MIND_MAPPING: 'Mind Mapping',
};

export const SKILL_STATE = {
  OPEN: 'open',
  COMPLETED: 'completed',
  INACTIVE: 'inactive',
};

export const SKILL_CATEGORY = {
  SOUNDS: 'Sounds',
  LETTERS: 'Letters',
  IMAGES: 'Images',
  IDEAS: 'Ideas',
  WORDS: 'Words',
};

export const FOCUS_INDICATOR_OUTLINE_WHITE = '#FFF';
export const FOCUS_INDICATOR_BORDER_DARK_BLUE = '#100163';

export const FOCUS_INDICATOR_STYLE = `
  border: 3px solid transparent;
  outline: 4px solid transparent;

  &:focus-visible {
    border-color: ${FOCUS_INDICATOR_BORDER_DARK_BLUE};
    outline-color: ${FOCUS_INDICATOR_OUTLINE_WHITE};
  }
`;

export const RETRY_ATTEMPTS = 3;
export const RETRY_TIMEOUT = 5000;
export const RETRY_TIMEOUT_SHORT = 1000;
export const GO_TO_MAP_DELAY = 50;
export const LAUNCH_APP_DELAY = 1000;
export const REDIRECT_THRESHOLD = 2 * 60 * 1000;
export const BACKPACK_LIMIT_OVERRIDE = 'backpackLimitOverride';
export const REFRESH_TIMEOUT = 3000;
export const APP_REFRESH_LIMIT = 5 * 60 * 1000; // 5 minutes
export const CURIOSO_CUSTOMIZATION_LIMIT = 2 * 60; // 2 minutes (in seconds)
export const CLICK_DELAY = 10000;

export const SEASON = {
  GRADE_K_1: '1',
  GRADE_2_3: '2',
  GRADE_4_5: '3',
};

export const SEASON_PART = {
  A: 'A',
  B: 'B',
};

export const GRADES = {
  PRE_KINDERGARTEN: 'PK',
  KINDERGARTEN: 'KG',
  GRADE_1: '01',
  GRADE_2: '02',
  GRADE_3: '03',
  GRADE_4: '04',
  GRADE_5: '05',
  GRADE_6: '06',
  GRADE_7: '07',
  GRADE_8: '08',
};

export const LECTURA_GRADES = [GRADES.KINDERGARTEN, GRADES.GRADE_1, GRADES.GRADE_2];

export const DEMO_GRADES_BY_SEASON = {
  [SEASON.GRADE_K_1]: GRADES.GRADE_1,
  [SEASON.GRADE_2_3]: GRADES.GRADE_3,
  [SEASON.GRADE_4_5]: GRADES.GRADE_5,
};

export const FORMATTED_GRADES = {
  [GRADES.PRE_KINDERGARTEN]: 'Pre-Kindergarten',
  [GRADES.KINDERGARTEN]: 'Kindergarten',
  [GRADES.GRADE_1]: '1st Grade',
  [GRADES.GRADE_2]: '2nd Grade',
  [GRADES.GRADE_3]: '3rd Grade',
  [GRADES.GRADE_4]: '4th Grade',
  [GRADES.GRADE_5]: '5th Grade',
  [GRADES.GRADE_6]: '6th Grade',
  [GRADES.GRADE_7]: '7th Grade',
  [GRADES.GRADE_8]: '8th Grade',
};

export const ACTIVITIES = {
  BATTERY: 'battery',
  VOCAB: 'vocab',
  EREADER: 'eReader',
  TFE: 'TFE',
};

export const ACTIVITY_STATUS = {
  INACTIVE: 'inactive',
  CALL_TO_ACTION: 'callToAction',
  IDLE: 'idle',
  REWARD: 'reward',
  FINISHED: 'finished',
  FINISHED_CALL_TO_ACTION: 'finishedCallToAction',
  TRANSMISSION: 'transmission', // used for transmitter only
};

export const VOCAB_PROGRESS = {
  COMPLETE: 'finished',
  STARTED: 'started',
};

export const CURIOSO_TYPES_MAP = {
  scaly: 'cat',
  furry: 'beast',
  feathery: 'bird',
};

export const CURIOSO_SKINS = Object.keys(CURIOSO_TYPES_MAP);

export const REWARD_TYPES = {
  BOOK: 'book',
  PORTAL: 'portal',
};

export const GLOBAL_NAV_SCREENS = {
  MAP: 'Map',
  WORKSHOP: 'workshop',
  PROGRESS_SCREEN: 'ProgressScreen',
  LOADING: 'Loading',
};

export const ITEMS = {
  book: {
    301: {
      name: 'Zephrayan Chained Curtains',
      description: 'Spun from canvas and laced with pewter chains, ' +
        'these classic Zephrayan curtains could make any home a palace.',
      image: 'RewardChoiceCurtains1',
      myCollectionTab: 'curtains',
    },
    302: {
      name: 'Zephrayan Classical Music',
      description: '"Morning of the Sky Queen" by the Grego Zithod Orchestra',
      image: 'RewardChoiceMusic2',
      myCollectionTab: 'music',
    },
    303: {
      name: 'Zephrayan lighting',
      description: 'This shade of red brings to mind the warm, ' +
        'baked sands that stretch beneath Zephraya\'s floating isles.',
      image: 'RewardChoiceLight3',
      myCollectionTab: 'color',
    },
    304: {
      name: 'Tangerine',
      description: 'Orange you glad you have a Curioso that\'s so fashion forward?',
      image: 'RewardChoiceBook4',
      myCollectionTab: 'book',
    },
    305: {
      name: 'Azure',
      description: 'Did you hear about your Curioso\'s new azure coat?  It blue everyone away.',
      image: 'RewardChoiceBook5',
      myCollectionTab: 'book',
    },
    306: {
      name: 'Cimeran Crystal Music',
      description: '"Rain Pools\'" by the bard Marie Jugwater',
      image: 'RewardChoiceMusic6',
      myCollectionTab: 'music',
    },
    307: {
      name: 'Cimeran Tassled Curtains',
      description: 'Spider silk is used in nearly all Cimeran textiles. ' +
        'Its strength and velvety texture make it an easy choice for weavers.',
      image: 'RewardChoiceCurtains7',
      myCollectionTab: 'curtains',
    },
    308: {
      name: 'Cimeran lighting',
      description: 'Sure enough, the sky is the same the whole world over, ' +
        'but somehow it never looks quite as blue as it does over Cimera.',
      image: 'RewardChoiceLight8',
      myCollectionTab: 'color',
    },
    309: {
      name: 'Gran Folie Parlor Music',
      description: '"The Gargoyle Tango" (traditional) arranged by Ludwing Fang  ',
      image: 'RewardChoiceMusic9',
      myCollectionTab: 'music',
    },
    310: {
      name: 'Gran Folie lighting',
      description: 'This shade of violet sets the perfect tone for secret plotting and moody brooding.',
      image: 'RewardChoiceLight10',
      myCollectionTab: 'color',
    },
    311: {
      name: 'Amethyst',
      description: 'That\'s the biggest turnip I\'ve ever seen.',
      image: 'RewardChoiceBook11',
      myCollectionTab: 'book',
    },
    312: {
      name: 'Gran Folie Striped Curtains',
      description: 'Made by the famous Folian designer Claude Dripp, ' +
        'these curtains are recycled from the cloaks of former Bureau agents.',
      image: 'RewardChoiceCurtains12',
      myCollectionTab: 'curtains',
    },
    313: {
      name: 'Dworp Dance Music',
      description: '"Wire Walk" by #ROC7',
      image: 'RewardChoiceMusic13',
      myCollectionTab: 'music',
    },
    314: {
      name: 'Dworp Jeweled Curtains',
      description: 'Curtains of this style and refinement are only found in the homes of Dworp\'s stylish upper crust.',
      image: 'RewardChoiceCurtains14',
      myCollectionTab: 'curtains',
    },
    315: {
      name: 'Citron',
      description: 'It looks like your Curioso still needs a few more days to ripen.',
      image: 'RewardChoiceBook15',
      myCollectionTab: 'book',
    },
    316: {
      name: 'Dworp lighting',
      description: 'The famous cave worms of Dworp shed a particular yellow light found nowhere else in Vista.',
      image: 'RewardChoiceLight16',
      myCollectionTab: 'color',
    },
  },
  portal: {
    301: {
      name: 'Ship Carving',
      description: 'An old toy ship to remember Zephraya’s ancient history.',
      image: 'RewardCr1',
      myCollectionTab: 'desk',
    },
    302: {
      name: 'Sky-ship Goggles',
      description: 'A pair of captain’s goggles found on the scavenged sky-ship. A reminder of old Zephraya.',
      image: 'RewardCr2',
      myCollectionTab: 'desk',
    },
    303: {
      name: 'Floatium Nugget',
      description: 'A “rescued” chunk of Floatium from the Adventurer’s Club. It’s the stuff that made Zephraya fly!',
      image: 'RewardCr3',
      myCollectionTab: 'desk',
    },
    304: {
      name: 'Real History of Zephraya',
      description: 'It wasn\'t easy, but we located the Real History of Zephraya! Keep it safe.',
      image: 'RewardCr4',
      myCollectionTab: 'desk',
    },
    305: {
      name: 'Cimeran Snowball',
      description: 'A Cimeran snowball! They last forever and are perfect for a friendly snowball fight!',
      image: 'RewardCr5',
      myCollectionTab: 'desk',
    },
    306: {
      name: 'Cimeran Deck of Cards',
      description: 'This deck of Cimeran cards is most unusual. They\'re not like any other cards I\'ve seen.',
      image: 'RewardCr6',
      myCollectionTab: 'desk',
    },
    307: {
      name: 'Clothes Pins',
      description: 'Clothespins should really be part of our regular gear. Keep these handy — you never know! ',
      image: 'RewardCr7',
      myCollectionTab: 'desk',
    },
    308: {
      name: 'Real History of Cimera',
      description: 'Here’s the second of the Real Histories! It’s been a long road, but we\'re making progress.',
      image: 'RewardCr8',
      myCollectionTab: 'desk',
    },
    309: {
      name: 'Carriage Map',
      description: 'This map shows every single carriage line, from Shrieker Heights to Lower Nightshade. All aboard!',
      image: 'RewardCr9',
      myCollectionTab: 'desk',
    },
    310: {
      name: 'A Ghost Caramel',
      description: 'Here\'s a ghost caramel from the Grisly Arms. Found on a hotel pillow. Watch your teeth!',
      image: 'RewardCr10',
      myCollectionTab: 'desk',
    },
    311: {
      name: 'Singing Puppet',
      description: 'An old Gran Folie Singing Puppet from the museum! Enjoy its harmonic laughter!',
      image: 'RewardCr11',
      myCollectionTab: 'desk',
    },
    312: {
      name: 'Real History of Gran Folie',
      description: 'Our third Real History! Keep this safe with the others. We need the complete set!',
      image: 'RewardCr12',
      myCollectionTab: 'desk',
    },
    313: {
      name: 'Olivia’s Climbing Gear',
      description: 'Hold onto this trusty climbing gear from Cimera! Great for mountains and caves! ',
      image: 'RewardCr13',
      myCollectionTab: 'desk',
    },
    314: {
      name: 'Slime Pop',
      description: 'Can\'t get enough of these slime pops! Mm! Here\'s one for you.',
      image: 'RewardCr14',
      myCollectionTab: 'desk',
    },
    315: {
      name: 'ZipRail Ticket',
      description: 'Dworp’s ZipRail system wouldn\'t exist without the help of the other lands of Vista.',
      image: 'RewardCr15',
      myCollectionTab: 'desk',
    },
    316: {
      name: 'The Real History of Dworp',
      description: 'This is it! The last of the Real Histories! Now,' +
        'finally, we have everything we need to understand the Codex!',
      image: 'RewardCr16',
      myCollectionTab: 'desk',
    },
  },
};

export const WORKSHOP_BENCHMARK_IDS = {
  WELL_BELOW: 'WELL_BELOW',
  NORMAL: 'NORMAL',
};

// Which eReader books a student gets per Season 3 quest. Separate from WORKSHOP_BENCHMARK_IDS
// because the book split is BP-only: AP04/AP05 students are WELL_BELOW for games but keep normal books.
export const WORKSHOP_BOOK_TRACK_IDS = {
  WBB_BP: 'WBB_BP',
  NORMAL: 'NORMAL',
};
